import { render, staticRenderFns } from "./AiCard.vue?vue&type=template&id=971612e6&scoped=true&"
import script from "./AiCard.vue?vue&type=script&lang=js&"
export * from "./AiCard.vue?vue&type=script&lang=js&"
import style0 from "./cards.css?vue&type=style&index=0&id=971612e6&scoped=true&lang=css&"
import style1 from "./AiCard.vue?vue&type=style&index=1&id=971612e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971612e6",
  null
  
)

export default component.exports